// longitude = d'est en ouest
// latitude = du nord au sud

// DOM elements - will be initialized in mmInitMap
let placeCardTemplate;
let placesContainer;
let showroomsContainer;
let storesContainer;
let placesJSONEl;
let filterIconsJSONEl;
let mapboxTokenInput;
let geocoderWrapper;

// Configuration
const PLACE_SELECTED_CLASS = 'selected';
const MARKER_DEFAULT_COLOR = '#ffffff';
const MARKER_SELECTED_COLOR = '#000000';
let SHOWROOM_MARKER_URL;
const FLY_TO_PLACE_ON_CLICK_ON_CARD = false;
const FLY_TO_PLACE_ON_CLICK_ON_MARKER = false;
const CENTER_MAP_ON_MARKER_ON_CLICK_ON_CARD = true;
let MAP_STYLE;

class Place {
	constructor(placeData) {
		this.name = placeData.name || '';
		this.address = placeData.address || '';
		// Support both formats: Longitude/Latitude (old) and longitude/latitude (new)
		this.coordinates = [
			parseFloat(placeData.longitude || placeData.Longitude) || 0,
			parseFloat(placeData.latitude || placeData.Latitude) || 0
		];
		this.url = placeData.url || placeData.calendly_link || '';
		this.filter = placeData.filter || 'popote_boutique';
		this.country = placeData.country || '';
		this.always_visible = placeData.always_visible || false;
	}

	get listContainer() {
		return showroomsContainer;
	}

	get markerIconUrl() {
		// Use filter-specific icon if available, otherwise use default
		return filterIcons[this.filter] || SHOWROOM_MARKER_URL;
	}

	buildPopup() {
		// Get translated text from template
		const template = document.getElementById('mm-map-place-template');
		const templateCard = template?.content?.querySelector('.mm-map-place-card');
		const seeStoreText = templateCard?.dataset?.seeStoreText || 'Voir l\'itinéraire';
		
		if (this.url && this.url !== '') {
			return new mapboxgl.Popup().setHTML(`
				<div class="mm-map-place-card mm-flex mm-column mm-gap-2">
					<p class="mm-text-lg-bold">${this.name}</p>
					<p class="mm-text">${this.address}</p>
					<button 
						class="mm-btn-map-card mm-underline" 
						type="button" 
						onclick="mmGoToMap('${encodeURIComponent(this.url)}')"
					>
						${seeStoreText}
					</button>
				</div>
			`);
		} else {
			return new mapboxgl.Popup().setHTML(`
				<div class="mm-map-place-card mm-flex mm-column mm-gap-2">
					<p class="mm-text-lg-bold">${this.name}</p>
					<p class="mm-text">${this.address}</p>
				</div>
			`);
		}
	}
}

// Will be initialized in mmInitMap
let places = [];
let filterIcons = {};

function mmInsertPlaceCard(place) {
	const card = placeCardTemplate.content.cloneNode(true).firstElementChild;
	const nameEl = card.querySelector('[data-place-name]');
	nameEl.textContent = place.name;
	const addressEl = card.querySelector('[data-place-address]');
	addressEl.textContent = place.address;
	const ctaEl = card.querySelector('[data-place-cta]');
	
	// Set filter type as data attribute
	card.dataset.filter = place.filter;
	
	// Set icon URL as CSS custom property for pseudo-element
	const iconUrl = filterIcons[place.filter];
	if (iconUrl) {
		card.style.setProperty('--place-icon', `url("${iconUrl}")`);
	}
	
	if (place.url && place.url !== '') {
		ctaEl.dataset.url = place.url;
	} else {
		ctaEl.style.display = 'none';
	}
	card.dataset.placeCoordinates = JSON.stringify(place.coordinates);

	placesContainer.appendChild(card);
}

function mmDisplayVisibleMarkers(map) {
	const {
		_ne: { lng: maxEast, lat: maxNorth },
		_sw: { lng: maxWest, lat: maxSouth },
	} = map.getBounds();

	let sumVisibleStores = 0;
	places.forEach((place) => {
		// const lng = places.coordinates.lng;
		// const lat = places.coordinates.lat;
		const [lng, lat] = place.coordinates; // [-1.557900, 47.214370]

		const visible = lng < maxEast && lng > maxWest && lat > maxSouth && lat < maxNorth;
		if (visible || place.always_visible == true) {
			mmInsertPlaceCard(place);
		}
	});
}

function mmFlyToPlaceByCoordinates(coordinates) {
	const map = window.mmMap;
	map.flyTo({ center: coordinates, zoom: 15 }, { placeCoordinatesToSelect: coordinates });
}

function mmCenterPlaceMarkerOnMap(coordinates) {
	const map = window.mmMap;
	map.flyTo({ center: coordinates }, { placeCoordinatesToSelect: coordinates });
}

function mmSelectPlaceByCoordinates(coordinates) {
	const placeCards = placesContainer.querySelectorAll('.mm-map-place-card');
	Array.from(placeCards).forEach((placeCard) => {
		placeCard.classList.remove(PLACE_SELECTED_CLASS);

		const [cardLng, cardLat] = JSON.parse(placeCard.dataset.placeCoordinates);
		const [lng, lat] = coordinates;
		if (cardLng === lng && cardLat === lat) {
			placeCard.classList.add(PLACE_SELECTED_CLASS);
		}
	});

	mmHighLightPlaceMarkerByCoordinates(coordinates);
}

function mmHighLightPlaceMarkerByCoordinates(coordinates) {
	const [lng, lat] = coordinates;
	const markers = document.querySelectorAll('#mm-map [data-marker-place-coordinates]');

	markers.forEach((marker) => {
		const [markerLng, markerLat] = JSON.parse(marker.dataset.markerPlaceCoordinates);
		const markerPath = marker.querySelector('path');

		// won't work with custom markers
		if (markerPath && markerLng === lng && markerLat === lat) {
			markerPath.setAttribute('fill', MARKER_SELECTED_COLOR);
		} else if (markerPath) {
			markerPath.setAttribute('fill', MARKER_DEFAULT_COLOR);
		}
	});
}

function mmInitMap() {
	// Initialize DOM elements
	placeCardTemplate = document.getElementById('mm-map-place-template');
	placesContainer = document.getElementById('mm-map-places');
	showroomsContainer = placesContainer?.querySelector('#mm-map-showrooms');
	storesContainer = placesContainer?.querySelector('#mm-map-stores');
	placesJSONEl = document.querySelector('#mm-places-json .metafield-json');
	filterIconsJSONEl = document.querySelector('#mm-filter-icons-json .filter-icons-json');
	mapboxTokenInput = document.getElementById('mm-mapbox-token');
	geocoderWrapper = document.querySelector('#mm-map-geocoder');
	
	// Initialize configuration values with fallbacks
	const mmMapMarker = document.getElementById('mmMapMarker');
	const mmMapSkin = document.getElementById('mmMapSkin');
	SHOWROOM_MARKER_URL = mmMapMarker?.dataset.markerUrl || '/assets/map-marker.svg';
	MAP_STYLE = mmMapSkin?.value || 'mapbox://styles/mapbox/streets-v11';
	
	// Check for required elements
	if (!mapboxTokenInput?.value) {
		console.error('MM Map: Mapbox token is required');
		return;
	}
	
	// Initialize mapbox and data
	mapboxgl.accessToken = mapboxTokenInput.value;
	
	// Load filter icons
	try {
		if (filterIconsJSONEl?.innerText?.trim()) {
			filterIcons = JSON.parse(filterIconsJSONEl.innerText);
		}
	} catch (error) {
		console.warn('MM Map: Error parsing filter icons data:', error);
		filterIcons = {};
	}
	
	// Load places data
	try {
		places = JSON.parse(placesJSONEl.innerText).map((placeData) => new Place(placeData));
	} catch (error) {
		console.error('MM Map: Error parsing places data:', error);
		return;
	}

	const placesGeoJSON = {
		type: 'FeatureCollection',
		features: places.map(place => ({
			type: 'Feature',
			properties: {
				name: place.name,
				address: place.address,
				url: place.url,
				filter: place.filter
			},
			geometry: {
				type: 'Point',
				coordinates: place.coordinates
			}
		}))
	};

	const map = new mapboxgl.Map({
		container: 'mm-map',
		style: MAP_STYLE,
		center: [2.25, 46.45],
		zoom: 4,
	});

	window.mmMap = map;

	mmCenterMapOnVisitorCountry(map);

	map.on('load', () => {
		map.addSource('places', {
			type: 'geojson',
			data: placesGeoJSON,
			cluster: true,
			clusterMaxZoom: 14, // zoom max pour clusteriser
			clusterRadius: 50   // rayon en px pour regrouper
		});

		// Layer => clusters
		map.addLayer({
			id: 'clusters',
			type: 'circle',
			source: 'places',
			filter: ['has', 'point_count'],
			paint: {
				'circle-color': '#fae9eb',
				'circle-radius': 25,
			}
		});

		// Layer => nombre dans cluster
		map.addLayer({
			id: 'cluster-count',
			type: 'symbol',
			source: 'places',
			filter: ['has', 'point_count'],
			layout: {
				'text-field': '{point_count_abbreviated}',
				'text-size': 12
			},
			paint: {
				'text-color': '#000'
			}
		});

		map.loadImage(SHOWROOM_MARKER_URL, (error, image) => {
			if (!map.hasImage('custom-marker')) {
				map.addImage('custom-marker', image);
			}
		});


		// Layer => points individuels (non clusterisés)
		map.addLayer({
			id: 'unclustered-point',
			type: 'symbol',
			source: 'places',
			filter: ['!', ['has', 'point_count']],
			layout: {
				'icon-image': 'custom-marker',
				'icon-size': 0.75
			}
		});

		map.on('click', 'clusters', (e) => {
			const features = map.queryRenderedFeatures(e.point, {
				layers: ['clusters']
			});
			const clusterId = features[0].properties.cluster_id;

			map.getSource('places').getClusterExpansionZoom(clusterId, (err, zoom) => {
				if (err) return;

				map.flyTo({
					center: features[0].geometry.coordinates,
					zoom: zoom
				});
			});
		});

		map.on('click', 'unclustered-point', (e) => {
			const feature = e.features[0];

			const {name, address, url} = feature.properties;
			let html = `<div class="mm-map-place-card">
						<p class="mm-text-lg-bold">${name}</p>
						<p class="mm-text">${address}</p>`;

			if (url)
				html += `
					<button 
						class="mm-btn-map-card mm-underline" 
						type="button" 
						onclick="mmGoToMap('${encodeURIComponent(url)}')"
					>
						Voir
					</button>
				`;
			
			html += `</div>`;

			new mapboxgl.Popup()
				.setLngLat(feature.geometry.coordinates)
				.setHTML(html)
				.addTo(map);
		});

	});

	// Add geocoded search in seperated div
	// https://docs.mapbox.com/mapbox-gl-js/example/mapbox-gl-geocoder-outside-the-map/
	
	// Get placeholder text from template
	const template = document.getElementById('mm-map-place-template');
	const templateCard = template?.content?.querySelector('.mm-map-place-card');
	const searchPlaceholder = templateCard?.dataset?.searchPlaceholder || 'Rechercher une ville';
	
	const geocoder = new MapboxGeocoder({
		mapboxgl: mapboxgl,
		accessToken: mapboxgl.accessToken,
		countries: 'fr,ch', // comma separated list
		placeholder: searchPlaceholder,
	});
	geocoderWrapper.appendChild(geocoder.onAdd(map));

	// Add geolocate control to the map.
	map.addControl(
		new mapboxgl.GeolocateControl({
			positionOptions: {
				enableHighAccuracy: true,
			},
			// When active the map will receive updates to the device's location as it changes.
			trackUserLocation: true,
			// Draw an arrow next to the location dot to indicate which direction the device is heading.
			showUserHeading: true,
		})
	);

	mmDisplayVisibleMarkers(map);
	
	// Initialize filter system
	mmInitFilters();

	map.on('moveend', (event) => {
		placesContainer.innerHTML = null;

		mmDisplayVisibleMarkers(map);

		// if move was triggered by mmFlyToPlaceByCoordinates, highlight card in list
		if (event.placeCoordinatesToSelect) {
			mmSelectPlaceByCoordinates(event.placeCoordinatesToSelect);
		}
	});

	placesContainer.addEventListener('click', (event) => {
		const target = event.target;

		const card = target.closest('.mm-map-place-card');
		if (card) {
			const coordinates = JSON.parse(card.dataset.placeCoordinates);
			if (FLY_TO_PLACE_ON_CLICK_ON_CARD && !CENTER_MAP_ON_MARKER_ON_CLICK_ON_CARD) {
				mmFlyToPlaceByCoordinates(coordinates);
			}
			if (CENTER_MAP_ON_MARKER_ON_CLICK_ON_CARD) {
				mmCenterPlaceMarkerOnMap(coordinates);
			}
		}
	});
}

// Center the map on the country of the current market (e.g. /fr-ch/ => CH).
// Falls back to Shopify's IP detection, then silently to the default center.
async function mmCenterMapOnVisitorCountry(map) {
	try {
		let countryCode = window.Shopify?.country;
		if (!countryCode) {
			const contextResponse = await fetch('/browsing_context_suggestions.json');
			countryCode = (await contextResponse.json())?.detected_values?.country?.handle;
		}
		if (!countryCode) return;

		const geocodeUrl = `https://api.mapbox.com/search/geocode/v6/forward?q=${countryCode}&types=country&country=${countryCode}&limit=1&access_token=${mapboxgl.accessToken}`;
		const geocodeResponse = await fetch(geocodeUrl);
		const bbox = (await geocodeResponse.json())?.features?.[0]?.properties?.bbox;
		if (!bbox) return;

		map.fitBounds(bbox, { padding: 20, duration: 0 });
	} catch (error) {
		console.warn('MM Map: Unable to center map on visitor country:', error);
	}
}

function mmGoToMap(encodedUrl) {
    const url = decodeURIComponent(encodedUrl);
    window.open(url, '_blank', 'noopener');
}

document.addEventListener('DOMContentLoaded', mmInitMap);

// Filter functionality
function mmInitFilters() {
	const filterButtons = document.querySelectorAll('[data-filter]');
	let activeFilter = null;
	
	filterButtons.forEach(button => {
		button.addEventListener('click', () => {
			const filterValue = button.dataset.filter;
			
			// Remove active class from all buttons
			filterButtons.forEach(btn => btn.classList.remove('mm-page-header__filter-btn--active'));
			
			// Toggle filter active state
			if (activeFilter === filterValue) {
				// Deactivate current filter
				activeFilter = null;
			} else {
				// Activate new filter
				activeFilter = filterValue;
				button.classList.add('mm-page-header__filter-btn--active');
			}
			
			// Apply filters to map
			mmApplyFilters(activeFilter);
		});
	});
}

function mmApplyFilters(activeFilter) {
    const filtered = !activeFilter
        ? places
        : places.filter(p => p.filter === activeFilter);

    const filteredGeoJSON = {
        type: 'FeatureCollection',
        features: filtered.map(place => ({
            type: 'Feature',
            properties: {
                name: place.name,
                address: place.address,
                url: place.url,
                filter: place.filter
            },
            geometry: {
                type: 'Point',
                coordinates: place.coordinates
            }
        }))
    };

    window.mmMap.getSource('places').setData(filteredGeoJSON);
}

function mmDisplayFilteredMarkers(map, filteredPlaces) {
	const {
		_ne: { lng: maxEast, lat: maxNorth },
		_sw: { lng: maxWest, lat: maxSouth },
	} = map.getBounds();

	filteredPlaces.forEach((place) => {
		const [lng, lat] = place.coordinates;
		const visible = lng < maxEast && lng > maxWest && lat > maxSouth && lat < maxNorth;
		if (visible || place.always_visible == true) {
			mmInsertPlaceCard(place);
		}
	});
}

function waitForElm(selector) {
	return new Promise((resolve) => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver((mutations) => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
}
